module.exports = __webpack_public_path__ + "static/women-of-wine-95f6872474fa1bb680a4bc497c5c68e5.jpg";